import { generateCentersCountText } from '../../../utils/generateCentersCountText'
import { normalizeInsuranceCard } from './normalizeInsuranceCard'
import { getColorInsuranceLogo } from '../../../utils/getColorInsuranceLogo'
import { isNil } from '../../../utils/checks'

export const getInsuranceMiniCardsFromTerms = (
  edges = [],
  termsCounts = [],
  locationSlug = '',
  location = ''
) => {
  if (!Array.isArray(edges)) {
    return []
  }

  return edges
    .filter((edge) => edge.node.type === 'accepted_insurance')
    .map((edge) => {
      const { node } = edge

      const termCount = termsCounts.find(
        ({ fieldValue }) => fieldValue === node.title
      )

      if (isNil(termCount)) {
        return null
      }

      const insuranceHasMatches = termCount?.totalCount > 0

      const pathnameHasTrailSlash =
        locationSlug[locationSlug.length - 1] === '/'

      const pathnameWithSlash = pathnameHasTrailSlash
        ? locationSlug
        : `${locationSlug}/`

      const slug =
        insuranceHasMatches && locationSlug !== 'united-states'
          ? `${pathnameWithSlash}${node.slug}`
          : `insurance/${node.slug}`
      const img = getColorInsuranceLogo(node.slug) || node.insurance_logo

      return {
        img,
        title: node.title || '',
        count: termCount?.totalCount,
        subTitle: generateCentersCountText(termCount?.totalCount),
        location,
        anchorTitle: node.title ? `Rehabs` : '',
        slug
      }
    })
    .filter(Boolean)
    .sort((itemA, itemB) => itemB.count - itemA.count)
}
